import React from 'react';
import { Separator } from './ui/separator';

const About = () => {
  return (
    <section className="py-12 md:py-16 max-w-2xl mx-auto">
      <Separator className="mb-12 md:mb-16 bg-border" />

      <div className="space-y-8">
        <h2 className="font-serif text-2xl md:text-2xl font-medium text-foreground mb-8 tracking-tight">The first spark</h2>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          I was introduced to computers at a very young age. At five, I used an Intel 486 for the first time at my father's office, and the idea of interacting with a machine through a keyboard immediately stuck with me.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          By 14, I had built my first freelance project for a client in Spain. That early experience taught me that software is about responsibility, delivery, and real-world impact—not just code.
        </p>

        <h2 className="font-serif text-2xl md:text-2xl font-medium text-foreground mb-8 tracking-tight">From local beginnings to global work</h2>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          I grew up in Firmat, Santa Fe, Argentina, a small town, but I always knew my career would be international.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          After graduating as an Information Systems Engineer, I moved to Australia. What began as a career move turned into a ten-year chapter of growth, where I built and scaled production systems, led engineering teams, worked across industries, and became an Australian citizen.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          That period shaped my technical standards and how I think about building reliable systems.
        </p>

        <h2 className="font-serif text-2xl md:text-2xl font-medium text-foreground mb-8 tracking-tight">Working across borders</h2>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          While in Australia, I realized I wanted to combine deep technical work with a more global way of living.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          After COVID, I returned to Argentina as a home base while continuing to work internationally. Today, I split my time between Argentina and traveling, working with distributed teams and global companies.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          This perspective strongly influences how I approach products and teams: resilient, distributed, and focused on outcomes.
        </p>

        <h2 className="font-serif text-2xl md:text-2xl font-medium text-foreground mb-8 tracking-tight">Engineering as a craft</h2>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          Technology has always been both my profession and a personal interest.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          I continue learning and writing code every day, bringing experience across front-end, back-end, full-stack development, infrastructure, team leadership, and consulting roles. This breadth allows me to understand how systems, teams, and businesses connect.
        </p>

        <h2 className="font-serif text-2xl md:text-2xl font-medium text-foreground mb-8 tracking-tight">Building engineering capability</h2>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          I co-founded Enabl after repeatedly seeing the same problem: companies struggle to build engineering teams that are both technically strong and consistently reliable.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          As Co-Founder and CTO, I focus on engineering standards, scalable architectures, and delivery practices that support long-term success.
        </p>

        <p className="font-sans text-base md:text-lg text-foreground/80 leading-relaxed">
          We don't just provide developers—we help companies build lasting engineering capability.
        </p>
      </div>
    </section>
  );
};

export default About;